import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const FlowCustomSqlQueryGql: DocumentNode = gql`
  query FlowCustomSqlQuery(
    $vizportalUrlId: String!,
    $selectedOutputStepId: ID!
  ) {
    flows(filter: { vizportalUrlId: $vizportalUrlId }) {
      outputSteps(filter: { id: $selectedOutputStepId }) {
        name
        outputFields {
          parentFields {
            ...on FlowColumnInputField {
              column {
                table {
                  ...on CustomSQLTable {
                    id
                    name
                    isUnsupportedCustomSql
                    query
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
